import React from 'react';
import { ActionButton } from '@adobe/react-spectrum';
import Close from '@spectrum-icons/workflow/Close';
import './cardStats.css';

/**
 * Active-filter banner — the colored strip that sits above a filtered
 * list showing the current selection plus a Clear (X) button. Used by
 * the CardsTab role/sub filter, CombosTab plan-mix filter, BaseDeckPane
 * category selection, and anywhere else a single active filter needs to
 * be surfaced.
 *
 * Props:
 * - `label`      — eyebrow text (e.g. "Showing", "Filtering by")
 * - `value`      — bold primary label (the active thing)
 * - `detail`     — optional right-side muted detail string
 * - `detailTitle`— tooltip for the detail (used for longer explanations)
 * - `color`      — accent color (border-left + value text). Defaults to
 *                  gold.
 * - `onClear`    — required. Callback for the X button.
 * - `ariaLabel`  — custom aria-label on the close button.
 */
export function FilterBanner({
    label,
    value,
    detail,
    detailTitle,
    color,
    onClear,
    ariaLabel = 'Clear filter',
    help,
}) {
    if (!value || !onClear) return null;
    const borderStyle = color ? { borderLeftColor: color } : undefined;
    const valueStyle = color ? { color } : undefined;
    return (
        <div className="comboFilterBanner" style={borderStyle}>
            {label && <span className="comboFilterLabel">{label}</span>}
            <span className="comboFilterValue" style={valueStyle}>
                {value}
            </span>
            {help && <span className="comboFilterHelp">{help}</span>}
            {detail && (
                <span className="comboFilterCount" title={detailTitle}>
                    {detail}
                </span>
            )}
            <ActionButton
                onPress={onClear}
                aria-label={ariaLabel}
                UNSAFE_style={{ width: 24, height: 24, marginLeft: 'auto' }}
                data-role="icon-only"
            >
                <Close />
            </ActionButton>
        </div>
    );
}
